import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29b13ed3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  density: "compact",
  class: "area-btns align-center d-flex justify-space-between w-100 gap-1"
}
const _hoisted_2 = {
  key: 0,
  class: "ponto"
}

import { withDefaults, ref, watch, onMounted } from 'vue';
import { IToggleButon } from '@/types';
interface IProps {
  buttons: Array<IToggleButon>;
  select?: any;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomToogleButton',
  props: {
    buttons: {},
    select: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ['handleToggle'],
  setup(__props: any, { emit: __emit }) {

const toggleBtn = ref('');

const props = __props;
const emit = __emit;
watch(
  () => toggleBtn.value,
  () => {
    emit('handleToggle', toggleBtn.value);
  }
);

watch(
  () => props.select,
  () => {
    if (props.select) {
      toggleBtn.value = props.select;
    }
  }
)

onMounted(() => {
  toggleBtn.value = props.buttons[0].value;
  if (props.select) {
    toggleBtn.value = props.select;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.buttons, (col, index) => {
      return (_openBlock(), _createBlock(_component_v_btn, {
        elevation: "0",
        onClick: ($event: any) => (toggleBtn.value = col.value),
        key: String(index),
        disabled: props.disabled,
        class: _normalizeClass(["btn-text", { active: toggleBtn.value === col.value }]),
        style: _normalizeStyle({ width: `${(100 / props.buttons.length) - 2}%` })
      }, {
        default: _withCtx(() => [
          (toggleBtn.value === col.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "."))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(col.text), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled", "style", "class"]))
    }), 128))
  ]))
}
}

})